// extracted by mini-css-extract-plugin
export default {"featureAdvisoryDescription":"FeatureAdvisoryForm_featureAdvisoryDescription__fu-y1","tokenInput":"FeatureAdvisoryForm_tokenInput__FXO8p"};